// Translations + services/pricing data for P&P Construction

export const PHONES = [
  { display: "0890 563 826", tel: "0890563826", name: "Шеко Кадиров" },
  { display: "0888 553 428", tel: "0888553428", name: "Петър Илиев" },
  { display: "0896 449 942", tel: "0896449942", name: "Петър Сираков" },
  
];
export const WHATSAPP = "359890563826";

export const LOGO = "https://static.prod-images.emergentagent.com/jobs/14f2726a-0678-436c-a0f0-b0c22d2319fc/images/2c840aec8ea5038b23db350a03c3705af3ee5e5587c2b65dc155189896e8bb41.jpeg";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1719561975005-d2c2b08c6ed8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  drywall: "https://images.unsplash.com/photo-1768321916886-30dc323bddf7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  painting: "https://images.unsplash.com/photo-1625559424722-7b7d1199ad6e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  about: "https://images.unsplash.com/photo-1706464287882-18cf0f772f79?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

const GAL_BASE = "https://customer-assets-m6fa6gv7.emergentagent.net/job_pp-construction/artifacts/";
export const GALLERY = [
  "pf0phsi2_fd0d2eb6-f80b-4786-a625-c99c03c9beab.webp",
  "nlvl0jzw_ecb9dfe3-3281-4ecf-a8b6-f909bbbf8143.jpg",
  "umvz6iyu_ebfd4fc2-182f-48ed-9c9f-f3e613685140.webp",
  "89qbf0yk_e4688202-a02d-41eb-af33-dd8a2d502651.webp",
  "dhkj783c_e893d07d-6dd0-4f0d-b357-f954b02e42dd.jpg",
  "f04ac41e_e077ca43-ab89-4d28-b97b-4fee505e2e65.jpg",
  "g0wnms84_e7c2807e-c9c2-4151-be57-a10ebb55f119.jpg",
  "k5g8zfjf_e6e48beb-bb12-4698-b140-d486b0f3397d.jpg",
  "l1tuhutj_d322c0cf-4d97-4d6e-8d05-73f089056bd0.jpg",
  "ox9ylt30_d31daf2c-044a-4e20-8d78-fe63f62fc8e6.jpg",
  "bpwi52sh_ca1c731d-96a9-4f7e-b12b-7c81fffb735e.webp",
  "to4phdwr_c4432239-c907-4e53-ac4e-b03298848a3c.jpg",
  "h1pxz47b_c82e6ecb-8823-4fc1-b235-1bd3d3551951.webp",
  "7fpqf9on_c6e14398-5300-4201-9106-7bcff4a79b98.webp",
  "m7tr34iq_bf073e3c-d70d-480b-a32a-55f07da2855d.webp",
  "ulhqeeip_78355689-458f-453e-ad2e-d63ec2bbf1fe.jpg",
  "nmhssxsj_28385395-88b3-4010-8d7e-eca36b78e1f9.jpg",
  "m5fkp83q_5707841a-185e-4740-ad1a-c2d99dca6d61.webp",
  "qoa31uc5_03208552-5aac-4b84-a028-e439e48bccbd.jpg",
  "rhf7zo1n_862b66d2-d6f4-4fe1-9846-103a5d827954.jpg",
  "vm933gvg_707e4c31-2ebe-4730-b494-aa3fb686afff.webp",
  "v2g8f95l_469b7a47-25fd-4b7a-a707-0cf288125be8.jpg",
  "rw5p7es2_81b62bbc-5820-4a18-b4f5-a200cb0f2454.jpg",
  "4jrksafk_2126fb6e-0fb5-45eb-9f96-61012f28e9e9.jpg",
  "mpw2hjog_64ef9cdf-fb10-4cb8-b7fb-6288b7319cf1.jpg",
  "wyhx0z79_28b91c40-2b4b-450d-81d3-263f581c2707.jpg",
  "kpfz72h3_8d2ef38f-7ce4-4134-a319-79c8da953c18.webp",
  "wbehsf1r_6e30e621-4430-4c98-ac99-2ca63a07ec2b.webp",
  "4fetg6zc_6b1397ce-d98d-4516-a99a-b6caf2ef6804.webp",
  "pksjpr5h_4eb53f1c-8516-4e46-86a0-3f65a60bd907.webp",
  "wzgaftn9_4b1e7d0b-7412-432d-a0c9-0f6747049cbe.webp",
  "vh6j6xz0_2b0c7020-7358-4231-81d7-e9ad327e528d%20%281%29.webp",
  "wljwgwmt_02e271e4-52d4-4c9a-88c2-72f3e709a632.webp",
].map((f) => GAL_BASE + f);

// Category per gallery image (same order as GALLERY). Values: drywall | tiles | concrete
export const GALLERY_CATS = [
  "drywall","tiles","tiles","concrete","tiles","tiles","drywall","concrete","tiles","concrete",
  "drywall","drywall","tiles","concrete","concrete","concrete","drywall","tiles","concrete","concrete",
  "drywall","drywall","tiles","tiles","tiles","drywall","drywall","drywall","tiles","concrete",
  "tiles","tiles","tiles",
];

// price: number = € per unit (numeric) | "8-10" range string | null = on request
// unit: "sqm" | "piece" | "flat" | null
export const SERVICE_GROUPS = [
  {
    key: "drywall", icon: "LayoutPanelTop",
    items: [
      { id: "ceiling", price: 20, unit: "sqm" },
      { id: "ceiling_double", price: 25, unit: "sqm" },
      { id: "drywall_double_layer", price: null },
      { id: "wall", price: 18, unit: "sqm" },
      { id: "figures", price: null },
      { id: "led", price: null },
    ],
  },
  {
    key: "plaster", icon: "PaintRoller",
    items: [
      { id: "gypsum_plaster", price: 12, unit: "sqm" },
      { id: "finish_plaster", price: 8, unit: "sqm" },
      { id: "paper_tape", price: 3, unit: "meter" },
      { id: "metal_corner", price: 3, unit: "meter" },
      { id: "sanding", price: 2.5, unit: "sqm" },
      { id: "painting", price: 7, unit: "sqm" }
    ],
  },
  {
    key: "tiles", icon: "LayoutGrid", note: true,
    items: [
      { id: "tile_standard", price: 40, unit: "sqm" },
      { id: "tile_large", price: 60, unit: "sqm" },
      { id: "plinth", price: 13, unit: "sqm" },
      { id: "laminate", price: 10, unit: "sqm" },
      { id: "vinyl", price: 15, unit: "sqm" },
    ],
  },
  {
    key: "doors", icon: "DoorOpen",
    items: [
      { id: "door_pvc", price: 50, unit: "piece" },
      { id: "door_interior", price: 65, unit: "piece" },
      { id: "door_armored", price: 100, unit: "piece" },
    ],
  },
  {
    key: "insulation", icon: "Layers",
    items: [
      { id: "wool", price: 1, unit: "sqm" },
    ],
  },
  {
    key: "external_insulation", icon: "Building2",
    items: [
      { id: "eps8", price: 36, unit: "sqm" },
      { id: "eps10", price: 41, unit: "sqm" },
      { id: "eps12", price: 45, unit: "sqm" },
      { id: "eps15", price: 53, unit: "sqm" },
      { id: "rockwool8", price: 50, unit: "sqm" },
      { id: "rockwool10", price: 65, unit: "sqm" },
      { id: "rockwool12", price: 68, unit: "sqm" },
      { id: "dowels", price: 2, unit: "sqm" },
      { id: "mesh_plaster", price: 10, unit: "sqm" },
      { id: "primer", price: 1.5, unit: "sqm" },
      { id: "decorative_plaster", price: "8-18", unit: "sqm" },
    ],
  },
  {
    key: "demolition", icon: "Hammer",
    items: [
      { id: "demo_tiles", price: 7, unit: "sqm" },
      { id: "demo_wall", price: 18, unit: "sqm" },
      { id: "demo_doors", price: 25, unit: "piece" },
    ],
  },
  {
    key: "other", icon: "Truck",
    items: [
      { id: "excavator", price: null },
      { id: "waste", price: null },
    ],
  },
  {
    key: "electrical", icon: "Zap",
    items: [
      { id: "el_point", price: "12-20", unit: "piece" },
      { id: "cables", price: 5, unit: "meter" },
      { id: "el_panel", price: 15, unit: "piece" },
      { id: "socket", price: 6, unit: "piece" },
    ],
  },
  {
    key: "plumbing", icon: "Droplet",
    items: [
      { id: "vik_point", price: 30, unit: "piece" },
      { id: "pipes", price: 18, unit: "meter" },
      { id: "boiler", price: 45, unit: "flat" },
    ],
  },
  {
    key: "cleaning", icon: "SprayCan",
    items: [
      { id: "cleaning_after", price: "3-5", unit: "sqm" },
      { id: "basic_cleaning", price: "50-150", unit: "flat" },
    ],
  },
];

export const T = {
  bg: {
    nav: { about: "За нас", services: "Услуги", pricing: "Цени", calc: "Калкулатор", gallery: "Галерия", contact: "Контакти", call: "Обади се" },
    gallery: { overline: "Галерия", title: "Нашите проекти", sub: "Реални обекти, изпълнени от екипа на P&P Construction — гипсокартон, мазилка, плочки, бани и външни ремонти.", cats: { all: "Всички", drywall: "Гипсокартон & тавани", tiles: "Плочки, камък & бани", concrete: "Бетон, основи & външни" } },
    hero: {
      overline: "P&P Construction",
      l1: "Строим", l2: "бъдещето", l3: "днес.",
      sub: "Иновация. Качество. Строителство.",
      motto: "Щастието ви е приоритет за нас!",
      cta1: "Виж цените", cta2: "Свържете се с нас",
    },
    marquee: "Иновация • Качество • Строителство • Щастието ви е приоритет за нас",
    about: {
      overline: "За нас",
      title: "Професионализъм, изграден на доверие",
      lead: "P&P Construction е екип от майстори, за които всеки детайл има значение. Работим с прецизност, спазваме сроковете и гарантираме резултата.",
      spec: "Безкомпромисно качество и 100% гаранция.",
      chapters: [
        { n: "01", t: "Професионализъм", d: "Опитен екип, който подхожда към всеки проект отговорно и с внимание към детайла." },
        { n: "02", t: "Качество", d: "Използваме доказани материали и техники за безупречен и дълготраен резултат." },
        { n: "03", t: "Гаранция", d: "Стоим зад свършената работа — предоставяме гаранция за всяка услуга." },
        { n: "04", t: "Коректни срокове", d: "Планираме реалистично и завършваме навреме. Думата ни е гаранция." },
      ],
    },
    services: {
      overline: "Услуги + Ценоразпис",
      title: "Прозрачни цени, без изненади",
      note: "ЦЕНИТЕ СА ОРИЕНТИРОВЪЧНИ.За точна оферта се свържете с нас за безплатен оглед.",
      tilesNote: "* Фугирането е включено в цените.",
      groups: {
        drywall: "Услуги с гипсокартон",
        plaster: "Вътрешни ремонти — шпакловка и боядисване",
        tiles: "Плочки и настилки",
        doors: "Монтаж на врати",
        insulation: "Изолация",
        external_insulation: "Външна изолация",
        demolition: "Къртене и демонтаж",
        other: "Мини багер и самосвал",
        electrical: "Електроуслуги",
        plumbing: "ВиК услуги",
        cleaning: "Почистване",
      },
      items: {
        ceiling: "Тавани от гипсокартон",
        ceiling_double: "Тавани от гипсокартон (двойна конструкция)",
        drywall_double_layer: "Двоен пласт гипсокартон",
        wall: "Стени от гипсокартон",
        figures: "Фигури и ниши от гипсокартон",
        led: "Поставяне на LED ленти (скрито/вкопано осветление)",
        gypsum_plaster: "Гипсова шпакловка с мрежа",
        finish_plaster: "Фина шпакловка",
        paper_tape: "Поставяне на хартиена лента",
        metal_corner: "Поставяне на метален ъгъл",
        sanding: "Безпрахово шкурене/шлайфане",
        painting: "Безвъздушно боядисване с машина",
        tile_standard: "Лепене на плочки — стандарт",
        tile_large: "Лепене на плочки — голям формат",
        plinth: "Лепене на цокъл",
        laminate: "Ламинат",
        vinyl: "Винил",
        door_pvc: "Монтаж на ПВЦ врата",
        door_interior: "Монтаж на интериорна врата",
        door_armored: "Монтаж на блиндирана врата",
        wool: "Полагане на изолационна вата",
        eps8: "EPS 8 см (труд и материали)",
        eps10: "EPS 10 см (труд и материали)",
        eps12: "EPS 12 см (труд и материали)",
        eps15: "EPS 15 см (труд и материали)",
        rockwool8: "Каменна вата 8 см",
        rockwool10: "Каменна вата 10 см",
        rockwool12: "Каменна вата 12 см",
        dowels: "Дюблиране",
        mesh_plaster: "Мрежа + шпакловка",
        primer: "Грунд",
        decorative_plaster: "Декоративна мазилка",
        demo_tiles: "Къртене на плочки",
        demo_wall: "Къртене на стена",
        demo_doors: "Демонтаж врати / прозорци",
        excavator: "Изкопи, насипи, почистване на терени с мини багер и извозване",
        waste: "Извозване на строителни отпадъци (с бус)",
        cleaning_after: "Почистване след ремонт",
        basic_cleaning: "Основно почистване",
        el_point: "Ел точка",
        cables: "Кабели",
        el_panel: "Свързване на ел. табло (на предпазител)",
        socket: "Поставяне на контакт",
        vik_point: "ВиК точка",
        pipes: "Смяна на тръби",
        boiler: "Монтаж на бойлер",
      },
      onRequest: "по договаряне след оглед",
      onRequest2: "по договаряне",
      perSqm: "€ / кв.м",
      perPiece: "€ / бр.",
      perMeter: "€ / м",
      flatUnit: "€",
      conditions: {
        title: "Допълнителни условия",
        items: [
          { t: "Минимален обект", v: "150 €" },
          { t: "Спешен ремонт (до 24ч)", v: "+30%" },
          { t: "Работа събота и неделя", v: "+20%" },
          { t: "Труд при труден достъп", v: "+10–30%" },
        ],
      },
    },
    calc: {
      overline: "Калкулатор",
      title: "Изчисли ориентировъчна цена",
      sub: "Избери услуга и въведи квадратура за моментална ориентировъчна оценка.",
      service: "Услуга", servicePh: "Избери услуга",
      area: "Квадратура (кв.м)", areaPh: "напр. 25",
      result: "Ориентировъчна цена",
      disclaimer: "* Ориентировъчна стойност. Крайната цена се определя след оглед.",
      cta: "Заяви оглед",
    },
    why: {
      overline: "Защо нас",
      title: "Причини да ни изберете",
      items: [
        { t: "Качество", d: "Безкомпромисен стандарт при всеки квадратен метър." },
        { t: "Коректност", d: "Честни цени и ясна комуникация от начало до край." },
        { t: "Спазени срокове", d: "Завършваме проектите навреме, всеки път." },
        { t: "Гаранция", d: "Гаранция за всяка извършена услуга." },
      ],
    },
    contact: {
      overline: "Контакти", title: "Свържете се с нас",
      lead: "Готови сме да обсъдим вашия проект. Обадете се или попълнете формата — ще се свържем с вас възможно най-скоро.",
      person: "Петър",
      name: "Име", namePh: "Вашето име",
      phone: "Телефон", phonePh: "Вашият телефон",
      service: "Услуга", servicePh: "Изберете услуга (по избор)",
      message: "Съобщение", messagePh: "Разкажете ни за проекта...",
      submit: "Изпрати по WhatsApp", sending: "Изпращане...",
      success: "Отваряме WhatsApp — изпратете запитването до Петър Илиев.",
      error: "Възникна грешка. Опитайте отново или ни се обадете.",
      whatsapp: "Пишете в WhatsApp",
    },
    footer: { slogan: "Строим бъдещето днес.", rights: "Всички права запазени." },
  },
  en: {
    nav: { about: "About", services: "Services", pricing: "Pricing", calc: "Calculator", gallery: "Gallery", contact: "Contact", call: "Call" },
    gallery: { overline: "Gallery", title: "Our projects", sub: "Real sites completed by the P&P Construction team — drywall, plaster, tiling, bathrooms and exterior works.", cats: { all: "All", drywall: "Drywall & ceilings", tiles: "Tiles, stone & baths", concrete: "Concrete, foundations & exterior" } },
    hero: {
      overline: "P&P Construction",
      l1: "We build", l2: "the future", l3: "today.",
      sub: "Innovation. Quality. Construction.",
      motto: "Your happiness is our priority!",
      cta1: "See pricing", cta2: "Get in touch",
    },
    marquee: "Innovation • Quality • Construction • Your happiness is our priority",
    about: {
      overline: "About us",
      title: "Professionalism built on trust",
      lead: "P&P Construction is a team of craftsmen who care about every detail. We work with precision, meet deadlines and guarantee the result.",
      spec: "Uncompromising quality & 100% guarantee.",
      chapters: [
        { n: "01", t: "Professionalism", d: "An experienced team that approaches every project responsibly and with attention to detail." },
        { n: "02", t: "Quality", d: "We use proven materials and techniques for a flawless, lasting result." },
        { n: "03", t: "Guarantee", d: "We stand behind our work — we provide a guarantee for every service." },
        { n: "04", t: "On-time delivery", d: "We plan realistically and finish on time. Our word is a guarantee." },
      ],
    },
    services: {
      overline: "Services + Pricing",
      title: "Transparent prices, no surprises",
      note: "Prices are indicative. For an exact quote, contact us for a free inspection.",
      tilesNote: "* Grouting is included in the prices.",
      groups: {
        drywall: "Drywall services",
        plaster: "Interior repairs — plastering & painting",
        tiles: "Tiles & flooring",
        doors: "Door installation",
        insulation: "Insulation",
        external_insulation: "External insulation",
        demolition: "Demolition & dismantling",
        other: "Mini excavator & dump truck",
        electrical: "Electrical services",
        plumbing: "Plumbing services",
        cleaning: "Cleaning",
      },
      items: {
        ceiling: "Drywall ceilings",
        ceiling_double: "Drywall ceilings (double frame)",
        drywall_double_layer: "Double layer drywall",
        wall: "Drywall walls",
        figures: "Drywall figures & niches",
        led: "LED strip installation (hidden/recessed lighting)",
        gypsum_plaster: "Gypsum plaster with mesh",
        finish_plaster: "Fine finishing plaster",
        paper_tape: "Paper tape application",
        metal_corner: "Metal corner bead installation",
        sanding: "Dustless sanding",
        painting: "Airless spray painting",
        tile_standard: "Tiling — standard",
        tile_large: "Tiling — large format",
        plinth: "Plinth tiling",
        laminate: "Laminate flooring",
        vinyl: "Vinyl flooring",
        door_pvc: "PVC door installation",
        door_interior: "Interior door installation",
        door_armored: "Armored door installation",
        wool: "Insulation wool installation",
        eps8: "EPS 8 cm (labor & materials)",
        eps10: "EPS 10 cm (labor & materials)",
        eps12: "EPS 12 cm (labor & materials)",
        eps15: "EPS 15 cm (labor & materials)",
        rockwool8: "Rock wool 8 cm",
        rockwool10: "Rock wool 10 cm",
        rockwool12: "Rock wool 12 cm",
        dowels: "Dowel fixing",
        mesh_plaster: "Mesh + plaster",
        primer: "Primer",
        decorative_plaster: "Decorative plaster",
        demo_tiles: "Tile removal",
        demo_wall: "Wall demolition",
        demo_doors: "Door / window dismantling",
        excavator: "Excavation, filling, site clearing with mini excavator & removal",
        waste: "Construction waste removal (with van)",
        cleaning_after: "Post-renovation cleaning",
        basic_cleaning: "Deep cleaning",
        el_point: "Electrical point",
        cables: "Cabling",
        el_panel: "Electrical panel wiring (per breaker)",
        socket: "Socket installation",
        vik_point: "Plumbing point",
        pipes: "Pipe replacement",
        boiler: "Water heater installation",
      },
      onRequest: "on request after inspection",
      onRequest2: "on request",
      perSqm: "€ / m²",
      perPiece: "€ / pc.",
      perMeter: "€ / m",
      flatUnit: "€",
      conditions: {
        title: "Additional conditions",
        items: [
          { t: "Minimum project", v: "150 €" },
          { t: "Urgent repair (within 24h)", v: "+30%" },
          { t: "Weekend work", v: "+20%" },
          { t: "Difficult-access labor", v: "+10–30%" },
        ],
      },
    },
    calc: {
      overline: "Calculator",
      title: "Estimate an indicative price",
      sub: "Pick a service and enter the area for an instant indicative estimate.",
      service: "Service", servicePh: "Choose a service",
      area: "Area (m²)", areaPh: "e.g. 25",
      result: "Indicative price",
      disclaimer: "* Indicative value. Final price is set after inspection.",
      cta: "Request inspection",
    },
    why: {
      overline: "Why us",
      title: "Reasons to choose us",
      items: [
        { t: "Quality", d: "Uncompromising standard on every square meter." },
        { t: "Fairness", d: "Honest prices and clear communication throughout." },
        { t: "On-time", d: "We finish projects on time, every time." },
        { t: "Guarantee", d: "A guarantee for every service performed." },
      ],
    },
    contact: {
      overline: "Contact", title: "Get in touch",
      lead: "We're ready to discuss your project. Call us or fill in the form — we'll get back to you as soon as possible.",
      person: "Petar",
      name: "Name", namePh: "Your name",
      phone: "Phone", phonePh: "Your phone",
      service: "Service", servicePh: "Choose a service (optional)",
      message: "Message", messagePh: "Tell us about your project...",
      submit: "Send inquiry", sending: "Sending...",
      success: "Thank you! Your inquiry was sent successfully.",
      error: "Something went wrong. Please try again or call us.",
      whatsapp: "Message on WhatsApp",
    },
    footer: { slogan: "We build the future today.", rights: "All rights reserved." },
  },
};
